import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import de from './locales/de.json';

// const LANGUAGES = ['en', 'fr', 'de'];

export default i18n
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    // debug: true,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en,
      de,
    },
  });